import StripShowcaseSdk from '@wix/thunderbolt-elements/src/components/StripShowcase/corvid/StripShowcase.corvid';


const StripShowcase = {
  sdk: StripShowcaseSdk
};


export const components = {
  ['StripShowcase']: StripShowcase
};

